import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class MovimientoPagoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerPagosRealizados(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: movimiento_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_pago {
              obtenerPagosRealizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    documento
                    referencia_documento
                    fecha_registro
                    fecha_vencimiento
                    monto
                    saldo
                    en_recorrido
                    tipo_cargo_codigo
                    cliente_proveedor_rut
                    tipo_movimiento_codigo
                    reversa_pago_codigo
                    reverso_pago_codigo
                    liquidacion_recorrido_pago_codigo
                    pago_codigo
                    saldo_documento_codigo
                    dia_registro
                    mes_registro
                    empresa_rut
                    sucursal_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.movimiento_pago.obtenerPagosRealizados;
            callback({ mensajes, respuesta });
        });
    }
    cartolaCliente(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: movimiento_pagoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            movimiento_pago {
              cartolaCliente(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    documento
                    pago_codigo
                    fecha_registro
                    fecha_vencimiento
                    referencia_documento
                    monto
                    cargo
                    abono
                    saldo
                    listaPagos {
                      empresa_rut
                      sucursal_codigo
                      codigo
                      tipo_pago_codigo
                      tipo_pago_nombre
                      monto
                    }
                  }
                }
              }
              saldoFinales(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  cargo
                  abono
                  monto
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes: mensajesDetalles, respuesta: respuestaDetalles } = response.data.movimiento_pago.cartolaCliente;
            const { mensajes: mensajesTotales, respuesta: respuestaTotales } = response.data.movimiento_pago.saldoFinales;
            callback({
                mensajesDetalles,
                respuestaDetalles,
                mensajesTotales,
                respuestaTotales,
            });
        });
    }
    obtenerCartolaExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: movimiento_pagoInputType) {
            movimiento_pago {
              obtenerCartolaExcel(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutaArchivo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.movimiento_pago.obtenerCartolaExcel;
            callback({ mensajes, respuesta });
        });
    }
    obtenerCartolaPDF(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: movimiento_pagoInputType) {
            movimiento_pago {
              obtenerCartolaExcel(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rutaArchivo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.movimiento_pago.obtenerCartolaExcel;
            callback({ mensajes, respuesta });
        });
    }
}
MovimientoPagoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MovimientoPagoService_Factory() { return new MovimientoPagoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: MovimientoPagoService, providedIn: "root" });
